import React, {
    useMemo
} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Redirect} from 'react-router';
import {LoginWrapper, Text, Loading, Spacer} from '../../components';
import taxProfileActions from '../../actions/TaxProfileActions';
import {InterviewFailed} from '../../components/payout/taxInfo/InterviewFailed';
import {useInterviewState, INTERVIEW_STATUS} from '../../hooks/useInterviewState';

const mapStateToProps = state => ({
    configState: state.get('config').toJS(),
    locale: state.get('localization').get('locale'),
    taxProfileState: state.get('taxProfile').toJS(),
    userState: state.get('user').toJS()
});

const mapDispatchToProps = {
    fetchProfileUpdates: taxProfileActions.fetchProfileUpdates,
    pullTaxProfile: taxProfileActions.pullTaxProfile,
    traceTakeInterview: taxProfileActions.traceTakeInterview,
    refreshTaxInterviewUrl: taxProfileActions.getInterview,
    getConsentTaxInterviewUrl: taxProfileActions.getConsentTaxInterview,
    resetInterviewCurrentUrl: taxProfileActions.resetInterviewCurrentUrl,
    resetInterviewFailed: taxProfileActions.resetInterviewFailed
};

const InterviewView = (props) => {
    const {
        configState,
        taxProfileState,
        userState,
        location
    } = props;

    const {
        status,
        shouldRedirect
    } = useInterviewState(props);

    const pending = taxProfileState.loadingUrl || status === INTERVIEW_STATUS.PENDING;

    const redirects = useMemo(() => ({
        notLoggedIn: !userState.isLoggedIn,
        noLocationState: !location.state,
        noEntitlement: userState.hasEsportEntitlement === false,
        shouldRedirect
    }), [userState, location.state, shouldRedirect]);

    if (redirects.notLoggedIn) {
        return <LoginWrapper productName="fortnite" />;
    }

    if (redirects.noLocationState) {
        return <Redirect to={`${configState.appContext}/prizes`} />;
    }

    if (redirects.noEntitlement) {
        return <Redirect to={configState.appContext} />;
    }

    if (redirects.shouldRedirect) {
        return <Redirect to={`${configState.appContext}/prizes`} />;
    }

    if (taxProfileState.error && taxProfileState.error.fetchUrlFailed) {
        return <InterviewFailed />;
    }

    const {eventName} = location.state || {};

    return (
        <div className="container interview-container" id="content">
            {!!eventName && (
                <Text as="h3" align="center">
                    Forms for {eventName}
                </Text>
            )}
            {pending ? (
                <Spacer padding={40}><Loading className="tp-load" /></Spacer>
            ) : (
                <>
                    <div className="loading-component">
                        <Loading className="tp-load" />
                    </div>
                    <iframe
                        className="taxid__interview"
                        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
                        src={taxProfileState.currentUrl}
                        title="Tax Identity Interview"
                    />
                </>
            )}
        </div>
    );
};

InterviewView.propTypes = {
    configState: PropTypes.object.isRequired,
    taxProfileState: PropTypes.object.isRequired,
    userState: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(React.memo(InterviewView));
